export default function() {
  this.loadProduct()

  if (this.$route.params.tripId) {
    this.preloadTrip(this.$route.params.tripId)
  }
}
